import "./IndividualStats.css";

function IndividualStats() {
  return <div className="stats-page"></div>;
}

export default IndividualStats;
